import {Component} from "@angular/core";
import {Platform} from "ionic-angular";
import {AppVersion} from "@ionic-native/app-version";
import {environment} from "../config/environment";

@Component({
  selector: 'app-app-version',
  template: `
  <ion-item>
    <ion-label>
     {{ 'profile.app_version' | translate }}
    </ion-label>
    <div item-content>
      <span *ngIf="nativeVersion">{{ nativeVersion }} - </span>
      {{ webVersion }}
    </div>
  </ion-item>
  `,
})
export class AppVersionComponent{
  nativeVersion: string;
  webVersion: string = environment.version;

  constructor(
    platform: Platform,
    appVersion: AppVersion
  ) {
    platform.ready().then(() => {
      if(platform.is('cordova')){
        appVersion.getVersionNumber().then((version) => this.nativeVersion = version);
      }
    });
  }


}



// WEBPACK FOOTER //
// ./src/app/components/app-version.component.ts